<template>
  <div class="page-container">
    <p>OTC 审核</p>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home/audit/otc/MerchantRecordList' }">♣</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/home/audit/otc/MerchantRecordList' }" v-if="rightsContains('OTC_MERCHANT_APPLY')">商户申请记录</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/home/audit/otc/OtcPayeeList' }" v-if="rightsContains('OTC_PAYEE_APPROVE')">收款人审核</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/home/audit/otc/OtcUpgradeList' }" v-if="rightsContains('OTC_MERCHANT_UPGRADE')">商户升级</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/home/audit/otc/AdAudit' }" v-if="rightsContains('OTC_ADVERTISING_APPROVE')">大额广告审核</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/home/audit/otc/OtcOrder' }" v-if="rightsContains('OTC_ORDER_APPROVE') || rightsContains('OTC_ORDER_APPEAL') ">订单审核</el-breadcrumb-item>
      <!-- <el-breadcrumb-item :to="{ path: '/home/audit/otc/orderAppeal' }">订单申诉</el-breadcrumb-item> -->
      <el-breadcrumb-item :to="{ path: '/home/audit/otc/orderAppeal2' }" v-if="rightsContains('OTC_ORDER_APPEAL')">订单申诉2.0</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/home/audit/otc/freeze' }" v-if="rightsContains('OTC_MERCHANT_FREEZE')">冻结</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/home/audit/otc/otcMerchantList' }" v-if="rightsContains('OTC_MERCHANT_MANAGE')">商户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content">
      <router-view></router-view>
    </el-card>
  </div>
</template>

<script>
import "./store";
import { mapState } from "vuex";
import { RIGHTS_TYPE } from "../../../common/constant";

export default {
  name: "KYC",
  data() {
    return {
      userId: null,
      activeTab: ""
    };
  },
  computed: {
    ...mapState(["userInfo", "userRights"])
  },
  components: {},
  methods: {
    rightsContains(r) {
      let rights = this.userRights.split(",") || [];
      return rights.indexOf(RIGHTS_TYPE[r]) !== -1;
    },
  },
  created() {}
};
</script>

<style lang="less" scoped>
.actions-bar {
  display: flex;
  align-items: center;
  .el-input {
    width: 300px;
    margin-right: 10px;
  }
}
</style>
